import * as React from 'react';
import { useParams } from 'react-router-dom';
import { basicValidation, fieldValidation, PortalLoginOptions } from '../../../../amorg-common';
import { clientApi } from '../../../../api/clientApi';
import { Button } from '../../../../designSystem/button/Button';
import { Card } from '../../../../designSystem/Card';
import { Flex } from '../../../../designSystem/compositeComponents/FlexHelpers';
import { TextField } from '../../../../designSystem/formField/text/TextField';
import { SingleColumnLayout } from '../../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../../designSystem/LoadingPageOverlay';
import { MessageCard } from '../../../../designSystem/Message';
import { PageHeader } from '../../../../designSystem/PageHeader';
import { PublicPageWrapper } from '../../../_pageWrappers/PublicPageWrapper';

// type loginMethod = 'none' |'magicLink';

export function PortalLoginPage(): JSX.Element {
    
    const params = useParams<{ siteId:string }>();
    const siteId = params.siteId || '';

    const [loginOptions, setLoginOptions] = React.useState<PortalLoginOptions | null>(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        async function getData() {
            if(fieldValidation.site.id(siteId))
            {
                const optionsResult = await clientApi.portal.getLoginOptions(siteId);
                setLoginOptions(optionsResult);
            }
            setLoading(false);
        }
        getData();
    },[siteId]);

    const showMagicLink = loginOptions !== null && loginOptions.enabled && loginOptions.method === 'magiclink';

    return (
            <PublicPageWrapper siteId={siteId}>

                <LoadingPageOverlay loading={loading} />
                <PageHeader narrow headerText="Log ind på arbejdsmiljøportalen"
                />
                <SingleColumnLayout narrow>
                    {(showMagicLink || loginOptions === null)
                        ?   <MagicLinkLoginPanel paramSiteId={siteId} />
                        :   <>
                                <p>
                                    Hov. Du har ikke adgang til medarbejderportalen.<br />
                                    Hvis du mener dette er en fejl, bør du kontakte din arbejdsmiljørepræsentat eller din administrator.
                                </p>
                            </>
                    }
                </SingleColumnLayout>                        
                        
            </PublicPageWrapper>
    );
}

type MagicLinkLoginPanelProps = {
    paramSiteId:string,
}
function MagicLinkLoginPanel(props:MagicLinkLoginPanelProps):JSX.Element
{
    const [siteId, setSiteId] = React.useState(props.paramSiteId || '');
    const [email, setEmail] = React.useState('');
    const [status, setStatus] = React.useState<'pending' | 'loading' | 'submitted' | 'error'>('pending');
    const [showInputError, setShowInputError] = React.useState(false);
     
    
    function handleEmailChange(newEmail:string)
    {
        setEmail(newEmail);
    }

    async function handleSubmit()
    {
        if(!basicValidation.isValidEmail(email) || !fieldValidation.site.id(siteId))
        {
            setShowInputError(true);
            return;
        }

        setShowInputError(false);
        setStatus('loading');

        // always returns success, since we don't want to reveal whether an email is in the system or not   
        const result = await clientApi.portal.requestMagicLink(siteId, email)
        if(result.isSuccess)
            setStatus('submitted');
        else
            setStatus('error');
    }

    return (

        <Flex flexDirection='column' gap={32} style={{maxWidth: '600px', margin: '0 auto'}}>

            {(status === 'pending' || status === 'loading') &&
                    <MessageCard variant="info" padding='16px'>
                        Log ind med din e-mail addresse. Så sender vi dig et link der giver adgang til portalen.
                    </MessageCard>
                }

                {status === 'submitted' &&
                    <p>
                        Vi har modtaget din anmodning. Hvis du har adgang til portalen, sender vi et link til dig indenfor kort tid. 
                    </p>
                }

                {status === 'error' &&
                    <p>
                        Hov! Der skete en fejl ved behandlingen af din anmodning. Prøv igen senere.
                    </p>
                }
            <Card variant='outlined' padding='16px'>

                <LoadingPageOverlay loading={status === 'loading'} />

                <Flex flexDirection="column" gap={24}>
                    {!props.paramSiteId &&
                        <TextField
                            label='Organisation'
                            disabled={status === 'loading' || status==='submitted'}
                            placeholder='Din organisation'
                            value={siteId}
                            errorMessage={showInputError
                                ? 'Indtast et gyldigt organisationsnavn'
                                : undefined
                            }
                            onChange={setSiteId}
                        />
                    }

                    <TextField
                        label='Email adresse'
                        disabled={status === 'loading' || status==='submitted'}
                        placeholder='email@domæne.dk'
                        value={email}
                        errorMessage={showInputError
                            ? 'Indtast en gyldig email adresse'
                            : undefined
                        }
                        onChange={handleEmailChange}
                    />

                    <Button variant='outlined'
                        disabled={status === 'loading' || status==='submitted' || email === ''}
                        text="Send link"
                        onClick={handleSubmit} 
                    />
                </Flex>
            </Card>
        </Flex>
    )
}

